import React from 'react';

const flightInfoBoxOuter = (props) => (
    <div className={`u-width100Percent u-flex f-row justify-content-between phone-f-column`}>
        {props.children}
    </div>
);

export default flightInfoBoxOuter;


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoBoxOuter/FlightInfoBoxOuter.js